export type FileStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'NO_FILE_UPLOADED';

// Per-file breakdown returned under the poll response's `files` map, keyed by
// object_id (discovery_entry_id). `statuses` is keyed by file_id (S3 key).
export interface FileStatusDetail {
  statuses: Record<string, FileStatus>;
  failed_file_ids: string[];
}

export interface Message {
  text: string;
  type: 'user' | 'ai';
  discovery_entry_id: string;
  file_ids?: string[];
  // Overall status for the whole attachment set (drives the IN_PROGRESS poll gate).
  file_upload_status?: FileStatus;
  // Per-file status keyed by file_id, so one failed file doesn't fail the batch.
  file_statuses?: Record<string, FileStatus>;
}

/**
 * The intents `/discovery_chat` accepts (`DiscoveryIntent` in the backend's
 * `doogly/discovery/discovery_intent.py`; any other value is refused).
 */
export type DiscoveryIntent = 'learn_about_you' | 'change_behaviour' | 'what_can_dooglie_do';

export interface DiscoveryButton {
  intent: DiscoveryIntent;
  label: string;
}

/**
 * The name to show for an attached file, from its file_id.
 *
 * A turn's attachments reach the conversation as file_ids only — both the turn
 * just sent and every turn `/get_discovery_conversation` returns — and a
 * file_id is the S3 key the backend minted as `<unix_ts>_<filename>`
 * (`vector_store.generate_presigned_uploads`). Showing it raw put
 * "1790342444_hartland-notes.txt" on the chip; the name is the part after the
 * timestamp. An id in any other shape is shown as it is.
 */
export function attachmentDisplayName(fileId: string): string {
  return fileId.replace(/^\d+_(?=.)/, '');
}
